// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error_main__wRClb {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100vw;
    height: calc(100vh - 70px);
    padding-top: 96px;
}

.error_content__OwDxW {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 44px;
    padding-bottom: 36px;
}

.error_title__lDIN8 {
    display: block;
    font-size: 3rem;
    font-weight: 600;
    text-align: center;
}

.error_subtitle__eHkIy {
    padding-top: 24px   ;
    display: block;
    font-size: 1.375rem;
    font-weight: 400;
    text-align: center;
    color: #595755;
}

.error_btn__PKvBx {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 14px 20px;
}

.error_btn__primary__OB0x8 {
    background-color: var(--primaryGreen);
    border-radius: 8px;
    font-weight: 500;
    font-size: 1.25rem;
    color: white;
}

.error_btn__secondary__4XkMP {
    background-color: var(--secondaryGreen);
    border-radius: 8px;
    font-weight: 500;
    font-size: 1.25rem;
    color: var(--primaryGreen);
}

.error_btn__group__iU-Em {
    display: flex;
    flex-direction: column;
    gap: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/fragments/error.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,uCAAuC;IACvC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb","sourcesContent":[".main {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100vw;\n    height: calc(100vh - 70px);\n    padding-top: 96px;\n}\n\n.content {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding-top: 44px;\n    padding-bottom: 36px;\n}\n\n.title {\n    display: block;\n    font-size: 3rem;\n    font-weight: 600;\n    text-align: center;\n}\n\n.subtitle {\n    padding-top: 24px   ;\n    display: block;\n    font-size: 1.375rem;\n    font-weight: 400;\n    text-align: center;\n    color: #595755;\n}\n\n.btn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 14px 20px;\n}\n\n.btn__primary {\n    background-color: var(--primaryGreen);\n    border-radius: 8px;\n    font-weight: 500;\n    font-size: 1.25rem;\n    color: white;\n}\n\n.btn__secondary {\n    background-color: var(--secondaryGreen);\n    border-radius: 8px;\n    font-weight: 500;\n    font-size: 1.25rem;\n    color: var(--primaryGreen);\n}\n\n.btn__group {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `error_main__wRClb`,
	"content": `error_content__OwDxW`,
	"title": `error_title__lDIN8`,
	"subtitle": `error_subtitle__eHkIy`,
	"btn": `error_btn__PKvBx`,
	"btn__primary": `error_btn__primary__OB0x8`,
	"btn__secondary": `error_btn__secondary__4XkMP`,
	"btn__group": `error_btn__group__iU-Em`
};
export default ___CSS_LOADER_EXPORT___;
